import * as CookieConsent from 'vanilla-cookieconsent';
import mapCookieCategoriesToGaConsent from '../mapCookieCategoriesToGaConsent';
import type { ConsentParams, CookieCategories } from '../../constants';
import normalizeConsentParams from '../normalizeConsentParams';
import storeConsent from '../storeConsent';

type Args = {
  cookie: CookieConsent.CookieValue;
  storageKey: string;
  setConsentState: (consent: ConsentParams) => void;
};

/**
 * Read the user's cookie choices and apply them.
 * - Get accepted categories from CookieBanner.
 * - Convert them to the 4 or 6 Google Analytics consent keys.
 * - Make sure all keys are present, save to localStorage, update state.
 * - Store consent to backend via storeConsent.
 */
const persistAndEmitConsentFromCookie = (args: Args): void => {
  const { cookie, storageKey, setConsentState } = args;

  /** E.g: ['necessary', 'analytics', 'marketing', 'functional'] */
  const acceptedCategories =
    cookie.categories && cookie.categories.length > 0
      ? (cookie.categories as Array<CookieCategories>)
      : (CookieConsent.getUserPreferences()
          ?.acceptedCategories as Array<CookieCategories>) ?? [];

  /**
   * Maps cookie categories to Google Consent Mode keys, then serializes safely to 4 or 6 keys.
   * Example output:
   * {
   *   "ad_storage": "denied" | "granted",
   *   "ad_user_data": "denied" | "granted",
   *   "ad_personalization": "denied" | "granted",
   *   "analytics_storage": "denied" | "granted",
   * }
   */
  const consent = normalizeConsentParams(
    mapCookieCategoriesToGaConsent(acceptedCategories),
  );

  localStorage.setItem(storageKey, JSON.stringify(consent));
  setConsentState(consent);
  void storeConsent(cookie);
};

export default persistAndEmitConsentFromCookie;
